import { NgModule } from '@angular/core';
import { DefaultComponentModule } from '@innogy/core/modules/components';
import { provideBootstrapEffects } from '@innogy/utils-state';
import { StoreModule } from '@ngrx/store';

import { MemberGetMemberEffects } from './member-get-member-state/member-get-member-state.effects';
import { memberGetMemberReducer } from './member-get-member-state/member-get-member-state.reducer';
import { memberGetMemberSelectorKey } from './member-get-member-state/member-get-member-state.selectors';
import { MemberGetMemberWidgetComponent } from './member-get-member-widget/member-get-member-widget.component';

const components = [MemberGetMemberWidgetComponent];

@NgModule({
  imports: [
    DefaultComponentModule,
    StoreModule.forFeature(memberGetMemberSelectorKey, memberGetMemberReducer),
  ],
  providers: [provideBootstrapEffects([MemberGetMemberEffects])],
  declarations: components,
  exports: components,
})
export class MemberGetMemberModule {}
